module.exports = __webpack_public_path__ + "static/fsi-d99469e8bed73aa4ea9da6cb2e5683ce.png";